import { Component } from '@angular/core';
import { MenuItem } from '../../../shared-components/custom-menu/custom-menu.component';

@Component({
	selector: 'app-menus',
	templateUrl: './menus.component.html',
	styleUrls: ['./menus.component.scss'],
	standalone: false,
})
export class MenusComponent {
	actionsMenuItems: MenuItem[] = [
		{
			text: 'File Operations',
			icon: 'fa-solid fa-file',
			children: [
				{
					text: 'New File',
					icon: 'fa-solid fa-plus',
					action: () => this.onAction('New File'),
				},
				{
					text: 'Open File',
					icon: 'fa-solid fa-folder-open',
					action: () => this.onAction('Open File'),
				},
				{
					text: 'Save File',
					icon: 'fa-solid fa-save',
					action: () => this.onAction('Save File'),
				},
			],
		},
		{
			text: 'Edit Operations',
			icon: 'fa-solid fa-edit',
			children: [
				{
					text: 'Cut',
					icon: 'fa-solid fa-cut',
					action: () => this.onAction('Cut'),
				},
				{
					text: 'Copy',
					icon: 'fa-solid fa-copy',
					action: () => this.onAction('Copy'),
				},
				{
					text: 'Paste',
					icon: 'fa-solid fa-paste',
					action: () => this.onAction('Paste'),
				},
			],
		},
		{
			divider: true,
			text: '',
		},
		{
			text: 'View Options',
			icon: 'fa-solid fa-eye',
			children: [
				{
					text: 'Zoom In',
					icon: 'fa-solid fa-magnifying-glass-plus',
					action: () => this.onAction('Zoom In'),
				},
				{
					text: 'Zoom Out',
					icon: 'fa-solid fa-magnifying-glass-minus',
					action: () => this.onAction('Zoom Out'),
				},
				{
					divider: true,
					text: '',
				},
				{
					text: 'Full Screen',
					icon: 'fa-solid fa-expand',
					action: () => this.onAction('Full Screen'),
				},
			],
		},
		{
			text: 'Settings',
			icon: 'fa-solid fa-cog',
			color: 'primary',
			action: () => this.onAction('Settings'),
		},
	];

	advancedMenuItems: MenuItem[] = [
		{
			text: 'View Details',
			icon: 'fa-solid fa-eye',
			action: () => this.onAction('View Details'),
		},
		{
			text: 'Edit Settings',
			icon: 'fa-solid fa-cog',
			color: 'success',
			action: () => this.onAction('Edit Settings'),
		},
		{
			divider: true,
			text: '',
		},
		{
			text: 'Archive',
			icon: 'fa-solid fa-archive',
			action: () => this.onAction('Archive'),
		},
		{
			text: 'Delete Permanently',
			icon: 'fa-solid fa-trash',
			color: 'danger',
			variant: 'standard',
			disabled: true,
			action: () => this.onAction('Delete Permanently'),
		},
	];

	multipleMenuItems: MenuItem[] = [
		{
			text: 'Confirming | Advance',
			action: () => this.onAction('Confirming | Advance'),
		},
		{
			text: 'Factoring | Advance',
			action: () => this.onAction('Factoring | Advance'),
		},
		{
			divider: true,
			text: '',
		},
		{
			text: 'Edit',
			icon: 'fa-solid fa-edit',
			color: 'success',
			action: () => this.onAction('Edit'),
		},
		{
			text: 'Share',
			icon: 'fa-solid fa-share-alt',
			color: 'info',
			action: () => this.onAction('Share'),
		},
		{
			text: 'Delete',
			icon: 'fa-solid fa-trash',
			color: 'danger',
			disabled: true,
			action: () => this.onAction('Delete'),
		},
	];

	lastAction: string = '';

	onMenuClick(event: { item: MenuItem; index: number; nestedIndex?: number }): void {
		if (event.nestedIndex !== undefined) {
			console.log(
				`Nested menu item clicked:`,
				event.item.text,
				`(Parent index: ${event.index}, Nested index: ${event.nestedIndex})`,
				event
			);
		} else {
			console.log(`Menu item clicked:`, event.item.text, event);
		}
		this.lastAction = event.item.text ?? '';
	}

	onPaymentAction(type: string): void {
		console.log(`Payment action: ${type}`);
		this.lastAction = type;
	}

	onAction(action: string): void {
		console.log(`Action performed: ${action}`);
		this.lastAction = action;
	}
}
